var map = {
	"./MSEM.webp": 2888,
	"./REMA.webp": 3041,
	"./arena_pod_draft.webp": 6925,
	"./cube_gathering.webp": 869,
	"./custom_magic.webp": 789,
	"./gauntlet_league_logo.webp": 5350,
	"./jank_diver_gaming.webp": 2693,
	"./limited_perspective.webp": 3825,
	"./mtg_cube_talk.webp": 1203,
	"./no_pain.webp": 8602,
	"./xdhs.webp": 5003
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7328;